import React from 'react'
import TabNavigation from './TabNavigation';
import SectionHeading from './SectionHeading';
import Footer from './Footer';
const Content = () => {
  return (
    <>
       <div className="container">
<SectionHeading />
<TabNavigation />
</div>
<Footer />
    </>
 

  )
}

export default Content